import { client } from './client'

const postNewConversationService = async (value: string, userId: string, type: string, cocap: string) => {
  const { data } = await client.post(
    '/conversation',
    { value, userId, type },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

export { postNewConversationService }
